<div
  [ngClass]="
    electionService.isMobile ? 'first-pref-table-phone' : 'first-pref-table'
  "
>
  <table mat-table [dataSource]="dataSource">
    <!-- Group Header Row -->
    <ng-container
      *ngFor="let group of groupHeaders; trackBy: trackByDistrictAndColumn"
      matColumnDef="{{ group.column }}"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        [attr.colspan]="group.colspan"
        [ngClass]="{ 'col-polling-place': group.column === 'groupPlace' }"
      >
        <div *ngIf="group.label">{{ group.label }}</div>
      </th>
    </ng-container>

    <!-- Candidate Header Row -->
    <ng-container
      *ngFor="let header of candidateHeaders; trackBy: trackByDistrictAndColumn"
      matColumnDef="{{ header.column }}"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        [attr.colspan]="header.colspan"
        [ngClass]="{
          'col-polling-place': header.column === 'candidatePlace',
          'candidate-header-right':
            header.column === 'candidateFormal' ||
            header.column === 'candidateInformal' ||
            header.column === 'candidateTotal'
        }"
      >
        <div
          *ngIf="header.colourCode !== null"
          class="candidate-header-block"
        >
          <mat-icon
            class="party-colour2"
            [ngStyle]="{ color: header.colourCode }"
          >
            rectangle
          </mat-icon>
          <div class="candidate-header-labels">
            <div>{{ header.label }}</div>
            <div class="candidate-header-abbr">{{ header.labelTwo }}</div>
          </div>
        </div>
        <div *ngIf="header.colourCode === null" class="candidate-header-total">
          {{ header.label }}
        </div>
      </th>
    </ng-container>

    <ng-container
      *ngFor="let col of columns; trackBy: trackByDistrictAndColumn; let i = index"
      matColumnDef="{{ col.column }}"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        [ngClass]="{
          'text-left': col.column === pollingPlaceColumn,
          'col-polling-place': col.column === pollingPlaceColumn,
          'col-votes': col.column.endsWith('_votes') || col.column === 'formal' || col.column === 'informal' || col.column === 'total',
          'col-percent': col.column.endsWith('_percent') || col.column.endsWith('_pct')
        }"
        class="column-header-cell"
      >
        <div class="column-header-content">
          <div class="column-header-line" *ngIf="col.isRightJustify === false">
            {{ col.label }}
          </div>
          <div
            class="value-justify-right column-header-line"
            *ngIf="col.isRightJustify === true"
          >
            {{ col.label }}
          </div>
          <div
            class="column-header-line2"
            *ngIf="col.labelTwo && col.isRightJustify === false"
          >
            {{ col.labelTwo }}
          </div>
          <div
            class="value-justify-right column-header-line2"
            *ngIf="col.labelTwo && col.isRightJustify === true"
          >
            {{ col.labelTwo }}
          </div>
        </div>
      </th>

      <td
        mat-cell
        *matCellDef="let element"
        [ngClass]="{
          'text-left': col.column === pollingPlaceColumn,
          'col-polling-place': col.column === pollingPlaceColumn,
          'col-votes': col.column.endsWith('_votes') || col.column === 'formal' || col.column === 'informal' || col.column === 'total',
          'col-percent': col.column.endsWith('_percent') || col.column.endsWith('_pct')
        }"
      >
        <div *ngIf="col.isColour" [style.width.px]="col.minWidth">
          <mat-icon
            class="party-colour"
            [ngStyle]="{ color: element.colourCode }"
          >
            rectangle
          </mat-icon>
        </div>
        <div
          [style.min-width.px]="col.minWidth"
          class="value-justify-right cell-number-wrap"
          *ngIf="col.isRightJustify && col.isPercent === false"
        >
          <div
            [ngClass]="
              isBold(element[pollingPlaceColumn]) ? 'text-bold' : 'text-plain'
            "
          >
            {{ element[col.column] | number }}
          </div>
        </div>
        <div
          [style.min-width.px]="col.minWidth"
          class="value-justify-right cell-number-wrap"
          *ngIf="col.isPercent"
        >
          <div *ngIf="col.isColourBar"></div>
          <div
            [ngClass]="
              isBold(element[pollingPlaceColumn]) ? 'text-bold' : 'text-plain'
            "
          >
            {{
              (element[col.column] === null ? "n/a" : element[col.column]) / 100
                | percent : "1.1-1"
            }}
          </div>
        </div>
        <div
          [style.min-width.px]="col.minWidth"
          *ngIf="col.isRightJustify === false && col.isColour === false"
        >
          <div
            [ngClass]="
              isBold(element[pollingPlaceColumn]) ? 'text-bold' : 'text-plain'
            "
          >
            {{ element[col.column] }}
          </div>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="groupHeaderColumns"
      class="group-header-row"
    ></tr>
    <tr
      mat-header-row
      *matHeaderRowDef="candidateHeaderColumns"
      class="candidate-header-row"
    ></tr>
    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
      class="column-header-row"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{ 'subtotal-row': isBold(row[pollingPlaceColumn]) }"
    ></tr>
  </table>
</div>
